// extracted by mini-css-extract-plugin
module.exports = {"salesPage":"SalesPage_salesPage__fth23","pageHeader":"SalesPage_pageHeader__1Uk5H","tableHeaders":"SalesPage_tableHeaders__2_Plh","infoPanels":"SalesPage_infoPanels__1oKzX"};